import React from 'react'
// import LoaderButton from './LoaderButton'
// import FormViewer from './FormViewer'
import { checkPermission, checkTranslation, chooseWallpaper, getObject, getPermissionObject, imageAddress, setObject, translate } from "../utils/useful";
// import Responsive from './Responsive';
// import TableViewer from './TableViewer';
// import SwitchInput from './inputs/SwitchInput';
// // import StageActionButton from '../../components/partials/StageActionButton';
// import AddPermissionModal from '../modals/AddPermissionModal';
// import SearchUsersModal from '../modals/SearchUsersModal';
// import SearchGroupsModal from '../modals/SearchGroupsModal';
import SidebarView from './SidebarView';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import ActionButton from './partials/ActionButton';
// import CAHeader from './header/CAHeader';
import ButtonAnimated from './buttons/ButtonAnimated';
import TextInput from './inputs/TextInput';
// import { nanoid } from 'nanoid';
// import SelectInput from './inputs/SelectInput';
// import Collapsible from 'react-collapsible';
// import CheckboxInput from './inputs/CheckboxInput';
// import FilterEditorInput from './inputs/FilterEditorInput';
// import RadiusSelectInput from './inputs/RadiusSelectInput';
// import HelpButton from './HelpButton';
import CollectionPermissionsView from './CollectionPermissionsView';
import { typeToPermission } from '../variables/PermissionsData';
import Modal from './Modal';

class PermissionsSidebarView extends React.Component {
    state = {

        actions: {
            edit: { key: "edit", label: "{{lang}}ca.Edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            remove: { key: "remove", label: "{{lang}}ca.Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
        },

        appletHeaders: {
            automations: {
                title: "{{lang}}Automations", horizontal: true, key: 'automations', permissions: {
                    view: { key: 'view', title: '{{lang}}View', main: true },
                    create: { key: 'create', dependancy: 'view', title: '{{lang}}Create', main: true },
                    edit: { key: 'edit', dependancy: 'view', title: '{{lang}}Edit', main: true },
                    remove: { key: 'remove', dependancy: 'view', title: '{{lang}}Remove', main: true },
                }
            },

            variables: {
                title: "{{lang}}Variables", horizontal: true, key: 'variables', permissions: {
                    view: { key: 'view', title: '{{lang}}View', main: true },
                    create: { key: 'create', dependancy: 'view', title: '{{lang}}Create', main: true },
                    edit: { key: 'edit', dependancy: 'view', title: '{{lang}}Edit', main: true },
                    remove: { key: 'remove', dependancy: 'view', title: '{{lang}}Remove', main: true },
                }
            },

            pages: {
                title: "{{lang}}Pages", horizontal: true, key: 'pages', permissions: {
                    view: { key: 'view', title: '{{lang}}View', main: true },
                    create: { key: 'create', dependancy: 'view', title: '{{lang}}Create', main: true },
                    edit: { key: 'edit', dependancy: 'view', title: '{{lang}}Edit', main: true },
                    remove: { key: 'remove', dependancy: 'view', title: '{{lang}}Remove', main: true },
                }
            },

            general: {
                title: "{{lang}}General", key: 'general', permissions: {
                    editInfo: { key: 'editInfo', title: '{{lang}}Edit collection information', main: true },
                    viewLog: { key: 'viewLog', title: '{{lang}}View activity log', main: true },
                    conditionalFormat: { key: 'conditionalFormat', title: '{{lang}}Manage conditional formating', main: true },
                }
            },

        },

        currentType: 'admins',
        permissionTab: 'frames',

        customAccess: {

        },

        frames: [],

        tabsView: {},

        admins: [],
        users: [],
        public: true,

        permissionsObject: {},


    }

    componentDidMount() {

    }

    open = () => {
        if (this.sidebarView) {
            this.sidebarView.open()
        }
        if (this.modalView) {
            this.modalView.showModal()
        }
    }



    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }







    changeAccess = (frame, permission, value, headers, parentKeyRef, type) => {


        // console.log("changeAccess",permission, value,parentKeyRef)


        let list = [...this.props.admins]
        let admin = list[this.props.currentItemIndex]
        let permissions = admin.permissions ?? []
        let framePermission
        let framePermissionIndex

        if (admin.locked) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}Can not change', description: "This is a locked permission and can not be changed." })
            return
        }
        // console.log('*changeAccess', frame, permission, value, headers, parentKeyRef, type)
        // console.log("permissions", permissions)
        // console.log("frame", frame)
        // console.log("permission", permission)
        // console.log("parentKeyRef", parentKeyRef)
        // console.log("headers", headers)

        let frameId = (frame._id ? frame._id : frame.id) ?? frame.key


        permissions.forEach((fpermission, index) => {

            let permissionId = fpermission.id ? fpermission.id : fpermission._id
            // console.log("permissionId",permissionId,frameId)
            if (permissionId == frameId) { // || fpermission._id == frame._id
                framePermission = fpermission
                framePermissionIndex = index
            }
        })

        if (!framePermission) {
            // console.log("HERE",framePermission)
            framePermission = { id: frameId, access: null, type: type ?? 'frame' }
        }

        // console.log("frameId",frameId,framePermission)




        let keys = ('access.' + (parentKeyRef ? (parentKeyRef + '.') : '') + permission.key).split('.')


        // console.log("keys",keys)

        let createdPermission = (value == "{}" ? {} : (value == "[]" ? [] : value))

        // console.log("createdPermission",createdPermission)


        for (let i = keys.length - 1; 0 < i; i--) {

            let parentKey = JSON.parse(JSON.stringify(keys))
            let keysToRemove = keys.length - i
            parentKey.splice((-1 * keysToRemove))
            parentKey = parentKey.join('.')

            let lastHeaders = headers
            if (Array.isArray(lastHeaders)) {
                lastHeaders = lastHeaders[lastHeaders.length - keysToRemove]
            }

            let myPermissionKey = keys[i]
            let myPermission = lastHeaders[myPermissionKey]

            createdPermission = this.createPermissionHierarchy(framePermission, myPermission, lastHeaders, createdPermission, parentKey)

            // console.log(createdPermission)

        }


        console.log("createdPermission2",createdPermission)

        setObject(framePermission, 'access', createdPermission)

        // console.log("framePermission", framePermission)
        //  actions.setPermissions(framePermission, parentKey, createdPermission)


        // let permissionValue = null//getPermissionObject(framePermission, parentKey).value

        // console.log("createdPermission", createdPermission)

        // console.log("framePermission", framePermission)


        // return
        if (!list[this.props.currentItemIndex].permissions) {
            list[this.props.currentItemIndex].permissions = []
        }


        if (framePermissionIndex != null) {
            list[this.props.currentItemIndex].permissions[framePermissionIndex] = framePermission
        } else {
            list[this.props.currentItemIndex].permissions.push(framePermission)
        }
        // let permissionsObject = this.props.permissionsObject

        // console.log("list",list)
        this.props.setAdmins(list, () => {
            this.props.setPermissionsObject()
        })
        // this.setState({ admins: list }, () => {
        //     this.permissionsToObject()
        // })

    }




    createPermissionHierarchy = (framePermission, permission, headers, value, parentKey) => {

        // let parentKey = [...keys].splice(keys.length - 1, 1).join('.')

        let parentValue = getPermissionObject(framePermission, parentKey).value
        let output = parentValue

        // let key = permission.key

        // let parentKeys = keys.split('.')

        // let headerParentKey = parentKey

        // parentKey = 'access.' + parentKey

        let myHeaders = headers
        // if (!childAccess) {
        //     myHeaders = getObject({ access: headers }, parentKey)
        // }

        if (output == '*') {

            output = {}

        }

        if (myHeaders) {
            Object.values(myHeaders).forEach(pheader => {

                if (pheader?.key == permission?.key) {

                    output = setObject(output, pheader.key, value)

                } else {

                    if (parentValue == '*') {

                        if (getPermissionObject(output, pheader.key).value == null) {
                            output = setObject(output, pheader.key, '*')
                        }
                    }

                    // console.log("permission.key",permission.key)
                    // console.log("pheader.dependancy",pheader.dependancy)
                    // console.log("value",value)

                    if (value == null) {

                        if (permission.key == pheader.dependancy) {
                            // if (headers[permission.key].dependancy == pheader.key) {
                            output = setObject(output, pheader.key, value == null ? null : '*')
                        }
                        // else {

                        //     if (parentValue == '*') {

                        //         if (getPermissionObject(output, pheader.key).value == null) {
                        //             output = setObject(output, pheader.key, '*')
                        //         }
                        //     }
                        // }

                    } else {

                        if (permission.key == pheader.dependancy) {
                            if (pheader.default && getPermissionObject(output, pheader.key).value == null) {
                                output = setObject(output, pheader.key, pheader.default)
                            }
                        }

                        if (myHeaders[permission.key]?.dependancy == pheader.key) {

                            if (getPermissionObject(output, pheader.key).value == null) {
                                output = setObject(output, pheader.key, '*')
                            }
                        }
                    }
                }
            })
        }


        if (output != '*' && output != null && typeof output == 'object') {

            // let keys = typeof parentValue == 'object' ? Object.keys(output) : []
            let keysCount = 0
            Object.values(output).forEach(element => {
                if (typeof element == 'string' && element.startsWith('*')) {
                    keysCount++
                }
            })

            if (keysCount == Object.keys(headers).length) {

                output = '*'
            }

            if (Object.keys(output).length == 0) {
                output = null
            }
        }

        return output


    }


    // permissionsToObject = () => {
    //     let admins = [...this.props.admins]
    //     let permissionsObject = {}


    //     admins.forEach(admin => {
    //         admin.permissions.forEach(permission => {

    //             // console.log(permission)
    //             let id = permission?._id ?? permission?.id
    //             permissionsObject[id] = permission.access
    //         });
    //     });

    //     // console.log(permissionsObject)
    //     // this.setState({ permissionsObject })
    //     this.props.setPermissionsObject(permissionsObject)

    // }


    fullAccessedClicked = (frame, type) => {
        // console.log('*fullAccessedClicked', frame, type)
        let list = [...this.props.admins]
        let admin = list[this.props.currentItemIndex]
        let permissions = admin.permissions
        let framePermission
        let framePermissionIndex


        if (admin.locked) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}Can not change', description: "This is a locked permission and can not be changed." })
            return
        }

        let frameId = (frame._id ? frame._id : frame.id) ?? frame.key
        permissions.forEach((fpermission, index) => {

            let permissionid = fpermission.id ? fpermission.id : fpermission._id
            if (permissionid == frameId) { // || fpermission._id == frame._id
                framePermission = fpermission
                framePermissionIndex = index
            }
        });


        if (!framePermission) {
            framePermission = { id: frameId, access: null, type: type ?? 'frame' }
        }
        // framePermission.access = '*'

        // console.log("framePermission", framePermission)

        let value = getPermissionObject(framePermission, 'access').value

        // console.log("framePermission", framePermission)
        // console.log("value", value)

        // return

        if (value == '*') {
            framePermission.access = null
        } else {
            framePermission.access = '*'
        }


        if (framePermissionIndex != null) {
            list[this.props.currentItemIndex].permissions[framePermissionIndex] = framePermission
        } else {
            list[this.props.currentItemIndex].permissions.push(framePermission)
        }

        // this.setState({ admins: list }, () => {
        //     this.permissionsToObject()
        // })
        // console.log('listp',list)

        this.props.setAdmins(list, () => {
            this.props.setPermissionsObject()
        })





    }


    // changeTabsView = (frameId, key, value) => {
    //     let tabsView = this.state.tabsView
    //     setObject(tabsView, frameId + '.' + key, value)

    //     if (key == 'showAdvanced' && value && !getObject(tabsView, frameId + '.advancedTab')) {

    //         setObject(tabsView, frameId + '.advancedTab', 'view')

    //     }
    //     this.setState({ tabsView })
    // }



    saveRoleAccess = () => {

        if (this.sidebarView) {
            this.sidebarView.close()
        }
        if (this.modalView) {
            this.modalView.hideModal()
        }

    }


    editRoleName = (key, value, extra) => {

        let list = [...this.props.admins]
        list[this.props.currentItemIndex].name = value

        this.props.setAdmins(list)
        // this.setState({ [this.state.currentType]: list })

    }

    setPermissionTab = (tab) => {
        this.setState({ permissionTab: tab })
    }


    adminInfoView(user, type) {
        if (user)
            return (
                <div className='flex-1 flexc mrd-2 text-semibold  '  >
                    <div className='mx-2 flexcc'>
                        {type == 'groups' ? (
                            <img className='task-check-img' src={'/images/icons/comunities.png'} height={30} width={30} style={{ borderRadius: 20 }} />
                        ) : (
                            <img className='task-check-img' src={imageAddress(user.image, 'profile')} height={30} width={30} style={{ borderRadius: 20 }} />
                        )}
                    </div>

                    <div className='flexc w-100' style={{ maxWidth: 'calc(100% - 35px)' }}>

                        <div className='w-100'>
                            <p className='  text-small text-semibold  cursor-pointer w-100' style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{user.fullname ?? user.name}</p>
                            <p className='  text-smallest  cursor-pointer' style={{ color: '#666' }}>{user.username ? ("@" + user.username) : translate("Group")}</p>
                        </div>


                    </div>
                </div>
            )
    }



    renderContent = () => {

        let admin = this.props.admins ? (this.props.admins[this.props.currentItemIndex] ?? {}) : {}
        let appletPermissions = (this.props.permissionsObject && this.props.permissionsObject[admin?.id]) ? this.props.permissionsObject[admin?.id]['applet'] : null

        if (admin)
            return (
                <>
                    {(this.props.currentItemIndex != null && this.state.currentType != null) && (


                        <div className={'h-100 scroll-no-scrollbar pb-5 ' + (this.props.editModalView ? 'br-8' : '')} style={{ backgroundColor: '#f8f8f8', }}>

                            <div className={'flexcb px-1 w-100 py-2 px-2 '} style={{ position: 'sticky', top: 0, zIndex: 1, borderBottom: '1px solid #eee', backgroundColor: '#fff', borderRadius: this.props.editModalView ? '8px 8px 0px 0px' : null }}>

                                <div className='' style={{ maxWidth: "calc(100% - 120px)" }}>
                                    {admin.type == 'role' && (
                                        <div className='flex-1 flexc mrd-2 text-semibold title-input'  >
                                            <TextInput data={admin?.name} header={{ information: { placeholder: 'Role name', disabled: (this.props.type == 'stage') } }} changeValue={this.editRoleName} />
                                        </div>
                                    )}

                                    {admin.type != 'role' && (
                                        this.adminInfoView(((admin.hubs && admin.hubs[0]) ? admin.hubs[0] : (admin.groups ? admin.groups[0] : null)))
                                    )}



                                </div>

                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.saveRoleAccess}
                                    title={translate('Submit')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    textColor={this.props.colors?.textColor}
                                    // invert={!this.props.colors?.iconInvert}
                                    bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                />
                            </div>

                            <div className=' px-0'>

                                {admin.type == 'role' && ((Array.isArray(admin.hubs) && admin.hubs.length > 0) || (Array.isArray(admin.groups) && admin.groups.length > 0)) && (

                                    <div className='px-2 pt-2 pb-1' style={{ backgroundColor: '#ffffff90', borderBottom: '1px solid #f2f2f2' }}>
                                        <div className='flexc mb-1 scroll-no-scrollbar'>
                                            {Array.isArray(admin.hubs) && (
                                                admin.hubs.map((hub, index) => {
                                                    return (
                                                        <div className='mrd-1 flexcc ' style={{ maxWidth: 75 }}>
                                                            <img className='task-check-img' src={imageAddress(hub.image, 'profile')} height={20} width={20} style={{ borderRadius: 20 }} alt='' />
                                                            <p className=' text-smallest text-semibold w-100 text-center mld-1 ' style={{ marginTop: 2, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{hub.fullname ?? hub.name}</p>
                                                        </div>
                                                    )
                                                })

                                            )}

                                            {Array.isArray(admin.groups) && (
                                                admin.groups.map((group, index) => {
                                                    return (
                                                        <div className='mrd-1 flexcc ' style={{ maxWidth: 75 }}>
                                                            <img className='task-check-img' src={'/images/icons/comunities.png'} height={20} width={20} style={{ borderRadius: 20 }} alt='' />
                                                            <p className=' text-smallest text-semibold w-100 text-center mld-1 ' style={{ marginTop: 2, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{group.fullname ?? group.name}</p>
                                                        </div>
                                                    )
                                                })

                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className=' mt-3 flexc mb-3 px-3'>


                                    {this.props.stage && (
                                        <button>
                                            <p className='text-bold text-normal pb-1 ' style={{ color: '#007aff', borderBottom: '2px solid #007aff' }}>{translate("Frame - stage")}</p>
                                        </button>
                                    )}

                                    {!this.props.stage && (
                                        <button onClick={() => this.setPermissionTab('frames')}>
                                            <p className='text-bold text-normal pb-1 ' style={{ color: this.state.permissionTab == 'frames' ? '#007aff' : '', borderBottom: this.state.permissionTab == 'frames' ? '2px solid #007aff' : '2px solid transparent' }}>{translate("Frames")}</p>
                                        </button>
                                    )}
                                    {this.props.applet && (
                                        <button className='mx-3' onClick={() => this.setPermissionTab('applet')}>
                                            <p className='text-bold text-normal  pb-1' style={{ color: this.state.permissionTab == 'applet' ? '#007aff' : '', borderBottom: this.state.permissionTab == 'applet' ? '2px solid #007aff' : '2px solid transparent' }}>{translate("Applet")}</p>
                                        </button>
                                    )}
                                </div>

                                {this.state.permissionTab != 'applet' && (
                                    <div>
                                        {this.props.frames?.map((frame, index) => {
                                            let admin = this.props.admins[this.props.currentItemIndex]

                                            let type = frame.pageType ?? frame.type
                                            // console.log('type!',type)
                                            if (type == 'collection' && this.props.type == 'stage') {
                                                type = 'stage'
                                            }
                                            // console.log('type', type, this.props.type, frame.pageType,frame)

                                            let permissionHeaders = typeToPermission[type] ?? { permissions: {} }
                                            return (
                                                <>
                                                    <CollectionPermissionsView key={index} frame={frame} permissionHeaders={permissionHeaders} changeAccess={this.changeAccess} admin={admin} permissionsObject={this.props.permissionsObject} permissionsType={this.props.permissionsType} fullAccessedClicked={this.fullAccessedClicked} type={this.props.type} stage={this.props.stage} previousHeaders={[]} isMain={true} />
                                                </>
                                            )
                                        })}
                                    </div>
                                )}



                                {this.state.permissionTab == 'applet' && (


                                    <div className='pt-2' style={{ border: '0px solid #f2f2f2', backgroundColor: '#fff' }}>

                                        <div className='flexcb  mb-1 px-3 pb-2 pt-0' style={{ borderBottom: '1px solid #eee' }}>
                                            <div className='flexc' >
                                                {/* <div className='br-4 p-1 flexcc' style={{ backgroundColor: '#eee' }}>
                                            <img src={'/assets/icons/useful/stack1.png'} width={20} alt='' />
                                        </div> */}
                                                <button className='p-0 flexcc' onClick={() => this.fullAccessedClicked({ id: 'applet' }, 'applet')} >
                                                    <div className={"checkbox-container position-relative " + ((appletPermissions && appletPermissions != '*') ? 'half-mark' : '')} >
                                                        <input type="checkbox" checked={appletPermissions ?? false} />
                                                        <span className="checkmark"></span>
                                                        <div style={{}} className='position-absolute top-0 left-0 w-100 h-100'>
                                                        </div>
                                                    </div>
                                                </button>

                                                <p className='text-bold text-small mb-1 mt-1 mld-2'>{'Applet permissions'}
                                                    {this.props.stage?.name && (<span>| {checkTranslation(this.props.stage?.name)}</span>)}
                                                </p>

                                                {admin?.locked && (
                                                    <div className=' p-1 mld-0 flexcc ' style={{ opacity: 0.3 }}>
                                                        <img src={'/assets/icons/useful/padlock.png'} width={16} />
                                                    </div>
                                                )}
                                            </div>


                                            {appletPermissions == '*' && (
                                                <div className='br-4' style={{ padding: '3px 4px', backgroundColor: 'rgb(0, 205, 116)', color: '#fff' }}>
                                                    <p className='text-smallest text-bold'>{translate('Full access')}</p>
                                                </div>
                                            )}

                                            {appletPermissions == null && (
                                                <div className='br-4' style={{ padding: '3px 4px', backgroundColor: 'rgb(238, 80, 80)', color: '#fff' }}>
                                                    <p className='text-smallest text-bold'>{translate("No access")}</p>
                                                </div>
                                            )}

                                            {(appletPermissions != null && appletPermissions != '*') && (
                                                <div className='br-4' style={{ padding: '3px 4px', backgroundColor: '#fc9d03', color: '#fff' }}>
                                                    <p className='text-smallest text-bold'>{translate("Partial access")}</p>
                                                </div>
                                            )}

                                        </div>

                                        <div className='px-3 mt-3'>
                                            {/* <p className='mb-2 text-small text-semibold required'>{translate("Records to remove")}</p> */}

                                            {Object.values(this.state.appletHeaders).map((header, index) => {

                                                let permissionStatus1 = getPermissionObject(appletPermissions, `${header.key}`)

                                                return (
                                                    <div className='mb-3 pb-2' style={{ borderBottom: Object.values(this.state.appletHeaders).length - 1 > index ? '1px solid #f2f2f2' : '' }}>
                                                        <button className='flexc' style={{ marginBottom: 10 }} onClick={() => {
                                                            this.changeAccess({ id: 'applet' }, { key: header.key }, (permissionStatus1.value == '*' ? null : '*'), [this.state.appletHeaders], null, 'applet')
                                                        }}>

                                                            <div className={"checkbox-container position-relative " + ((permissionStatus1.value && permissionStatus1.value != '*') ? 'half-mark' : '')}  >
                                                                <input type="checkbox" checked={permissionStatus1.allowed} />
                                                                <span className="checkmark"></span>
                                                                <div style={{}} className='position-absolute top-0 left-0 w-100 h-100'>
                                                                </div>
                                                            </div>
                                                            <p className=' mld-2 text-small text-bold'>{translate(header.title)}</p>

                                                        </button>

                                                        <div className={'' + (header.horizontal ? 'flexc' : '')}>

                                                            {Object.values(header.permissions).map((permission, j) => {

                                                                let permissionStatus = getPermissionObject(appletPermissions, `${header.key}.${permission.key}`)

                                                                return (
                                                                    <button className={'flexc mb-2 ' + (header.horizontal ? 'mrd-4' : '')} onClick={() => {
                                                                        this.changeAccess({ id: 'applet' }, { key: permission.key }, (permissionStatus.value == '*' ? null : '*'), [this.state.appletHeaders, header.permissions], `${header.key}`, 'applet')
                                                                    }}>

                                                                        <div className={"checkbox-container position-relative " + ((permissionStatus.value && permissionStatus.value != '*') ? 'half-mark' : '')}  >
                                                                            <input type="checkbox" checked={permissionStatus.allowed} />
                                                                            <span className="checkmark"></span>
                                                                            <div style={{}} className='position-absolute top-0 left-0 w-100 h-100'>
                                                                            </div>
                                                                        </div>
                                                                        {/* <SwitchInput header={{ information: {} }} changeValue={(key, value) => { this.changeAccess(frame, { key: permission.key }, value, [headers, this.state.manageHeaders], this.state.currentTab) }}/> */}
                                                                        <p className='mld-2 font-size-13 text-semibold'>{translate(permission.title)}</p>
                                                                    </button>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )
                                            })}

                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}
                </>
            )
    }


    render() {

        return (

            <>
                {this.props.editModalView ? (

                    <Modal maxWidth={400} ref={el => this.modalView = el} onHide={() => this.setState({ currentItem: null, currentItemIndex: null, tabsView: {} })}>
                        {this.renderContent()}
                    </Modal>
                ) : (

                    <SidebarView width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: '80%', md: '400px' }} onClosed={() => this.setState({ currentItem: null, currentItemIndex: null, tabsView: {} })} left={50}>
                        {this.renderContent()}
                    </SidebarView>
                )}




            </>

        )
    }
}

// export default PermissionsSidebarView


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(PermissionsSidebarView);
